import React from 'react';


import {Row, Col} from 'react-bootstrap';

import Biofilm from '../assets/Homepage/Biofilm.jpg';

import Icon1 from '../assets/Homepage/icon1.png';
import Icon1_Roll from '../assets/Homepage/icon1_roll.png';

import Icon2 from '../assets/Homepage/icon2.png';
import Icon2_Roll from '../assets/Homepage/icon2_roll.png';

import Icon3 from '../assets/Homepage/icon3.png';
import Icon3_Roll from '../assets/Homepage/icon3_roll.png';

import Icon4 from '../assets/Homepage/icon4.png';
import Icon4_Roll from '../assets/Homepage/icon4_roll.png';

import Icon5 from '../assets/Homepage/icon5.png';
import Icon5_Roll from '../assets/Homepage/icon5_roll.png';

import Family from '../assets/Homepage/family.png';
import Family_US from '../assets/Homepage/family_us_alt.png'
import FiveTimes from '../assets/Homepage/5x_dose_en.png';
import FiveTimes_Fr from '../assets/Homepage/5x_dose_fr.png';
import Intro from '../assets/Homepage/intro.jpg';
import JanBellows from '../assets/Homepage/JanBellows.jpg';
import NinetyTwo from '../assets/Homepage/ninety_two.png';
import Teeth from '../assets/Homepage/teeth.png';
import EightyTwo from '../assets/Homepage/eighty-two.png';

import '../css/Home.css';
import Page from "./Page";

class Home extends Page{

    constructor(props){
        super(props)
        this.state = {
            curr_feature:null
        }

        this.handleFeatureClick = this.handleFeatureClick.bind(this);
        this.handleActionClick = this.handleActionClick.bind(this);

    }

    handleFeatureClick(e){
        var curr_feature
        var state = this.state;
        curr_feature = parseInt(e.currentTarget.getAttribute("data"), 10);
        state.curr_feature = curr_feature;
        this.setState({state});

    }

    handleMouseOver(e){
        var id;
        id = parseInt(e.currentTarget.getAttribute("data"), 10);
        
        switch(id){
            case 1:
                e.target.src = Icon1_Roll
                break;
            case 2:
                e.target.src = Icon2_Roll
                break;
            case 3:
                e.target.src = Icon3_Roll
                break;
            case 4:
                e.target.src = Icon4_Roll
                break;
            case 5:
                e.target.src = Icon5_Roll
                break;
            default:
                console.log("BAD DATA TO MOUSEOVER EVENT");
                break;
                
        }        
    }
    
    handleMouseDown(e){
        var id;
        id =parseInt(e.currentTarget.getAttribute("data"), 10);
        switch(id){
            case 1:
                e.target.src = Icon1
                break;
            case 2:
                e.target.src = Icon2
                break;
            case 3:
                e.target.src = Icon3
                break;
            case 4:
                e.target.src = Icon4
                break;
            case 5:
                e.target.src = Icon5
                break;
            default:
                console.log("BAD DATA TO MOUSEOVER EVENT");
                break;

        }
    }
    
    handleMouseUp(e){
        var id;
        id = parseInt(e.currentTarget.getAttribute("data"), 10);
        switch(id){
            case 1:
                e.target.src = Icon1_Roll
                break;
            case 2:
                e.target.src = Icon2_Roll
                break;
            case 3:
                e.target.src = Icon3_Roll
                break;
            case 4:
                e.target.src = Icon4_Roll
                break;
            case 5:
                e.target.src = Icon5_Roll
                break;
            default:
                console.log("BAD DATA TO MOUSEOVER EVENT");
                break;
        }
    }
    
    handleMouseOut(e){
        var id;
        id = parseInt(e.currentTarget.getAttribute("data"), 10);
        switch(id){
            case 1:
                e.target.src = Icon1
                break;
            case 2:
                e.target.src = Icon2
                break;
            case 3:
                e.target.src = Icon3
                break;
            case 4:
                e.target.src = Icon4
                break;
            case 5:
                e.target.src = Icon5
                break;
            default:
                console.log("BAD DATA TO MOUSEOVER EVENT");
                break;

        }
    }

    componentDidMount() {
        document.title = "Vetradent™";
    }

    handleActionClick(){
        this.props.setPage("products");
    }

    render(){
        var IE = /*@cc_on!@*/false || !!document.documentMode;
        var family_image
        if(this.props.Settings.country === "CA"){
            family_image = Family;
        } else {
            family_image = Family_US;

        }

        var feature_icon = [];
        for (var i = 0; i < 5; i++) {
            feature_icon.push("feature-icon");
        }
        feature_icon[this.state.curr_feature] = "feature-icon-active";

        var five_times_img_src = this.props.Settings.language === 'en' ? FiveTimes : FiveTimes_Fr;

        var curr_feature = [];
        switch(this.state.curr_feature){
            case 0:
                curr_feature.push(
                    <div key = {this.state.curr_feature}  className = "home-chunk-feature">
                        <Row>
                            <Col xs={7}>
                                <h2>{this.contentParser("effective")}</h2>
                                <p>{this.contentParser("effective_text")}</p>
                            </Col>
                            <Col xs ={5} style={{textAlign:"center"}}>
                                <img src = {NinetyTwo} className = "feature-image" alt={"92 percent of dogs show improvement"} />
                            </Col>
                        </Row>
                    </div>
                );
                break;
            case 1:
                let five_times_image = []
                if(this.props.Settings.country !== "US"){
                    five_times_image.push(
                        <img src = {five_times_img_src}  className = "feature-image five_times_feature_image" alt={"Proven safe at 5x recommended dosage"} />
                    )
                }

                curr_feature.push(
                    <div  key = {this.state.curr_feature}  className = "home-chunk-feature">
                        <Row>
                            <Col xs={7}>
                                <h2>{this.contentParser("safe")}</h2>
                                <p>{this.contentParser("safe_text")}</p>
                            </Col>
                            <Col xs ={5} style={{textAlign:"center"}}>
                                {five_times_image}
                            </Col>
                        </Row>

                    </div>

                );

                break;
            case 2:
                curr_feature.push(
                    <div  key = {this.state.curr_feature}  className = "home-chunk-feature">
                        <Row>
                            <Col xs={6}>
                                <h2>{this.contentParser("easy")}</h2>
                                <p>{this.contentParser("easy_text")}</p>
                            </Col>
                            <Col xs ={6} >
                                <img src = {Teeth} className = "feature-image" alt={"Dog showing healthy teeth"} />
                            </Col>
                        </Row>

                    </div>
                );
                break;
            case 3:
                curr_feature.push(
                    <div  key = {this.state.curr_feature}  className = "home-chunk-feature">
                        <Row>
                            <Col xs={6}>
                                <h2>{this.contentParser("bad_breath")}</h2>
                                <p>{this.contentParser("bad_breath_text")} </p>
                            </Col>
                            <Col xs ={6} >
                                <img src = {EightyTwo} className = "feature-image" alt={"Eighty-two percent less bad breath"} />
                            </Col>
                        </Row>
                    </div>
                );
                break;
            case 4:
                curr_feature.push(
                    <div  key = {this.state.curr_feature}  className = "home-chunk-feature">
                        <Row>
                            <Col xs={6}>
                                <h2>{this.contentParser("cutting")}</h2>
                                <p>{this.contentParser("cutting_text")}</p>
                            </Col>
                            <Col xs ={6}>
                                <img src = {Biofilm} className = "feature-image" alt={"Biofilm diagram"} />
                            </Col>
                        </Row>
                    </div>
                );
                break;

            default:
                curr_feature.push(
                    null
                );
                break;
        }



        return(
             <div className="home">
                <div style={{backgroundImage:"url("+Intro+")"}} className = "home-chunk-intro">

                    <Row>
                        <Col xs={5}>
                            <img src={family_image} className = "home-products-img" alt="Vetradent Product Line" />
                            <a aria-label="products page" onClick={this.handleActionClick} className = "action-item">{this.contentParser("action-item")}  </a>
                        </Col>
                        <Col xs={7}>
                            <p> <span className = "home-strong-text">Vetradent</span>
                                <span className = "trade-mark">&trade; </span>
                                {this.contentParser("front-text")}
                            </p>

                        </Col>
                    </Row>
                </div>
                <div className = "home-flavor">

                </div>

                <div className = "home-chunk-testimony">
                    <Row>
                        <Col md={12} lg={5}>
                        <h2>{this.contentParser("oral_care_headline")}</h2>
                        <p>{this.contentParser("oral_care_text")}</p>
                        </Col>
                        <Col xsHidden={true} sm={4} md={4} lg ={2}>
                            <img src = {JanBellows} className = "vet-image" alt={"A real Vet"} />
                        </Col>
                        <Col xs={12} sm = {8} md={8} lg={5}>
                            <h2>{this.contentParser("testimony_headline")}</h2>
                            <p>{this.contentParser("testimony_text")}</p>
                            <p className = "italics">{this.contentParser("testimony_subtext")} </p>

                        </Col>

                    </Row>
                </div>
                <div className = "custom-hr"></div>
                <div className = "home-chunk-select-feature">
                    <h2 className = "italics">{this.contentParser("select_feature_headline")} </h2>
                    <Row className="row-fluid" style={{textAlign:"center"}}>
                        <Col className="col-xs-5th">
                            <a onClick = {this.handleFeatureClick} data="0">
                                <img onMouseOver = {this.handleMouseOver} onMouseDown={this.handleMouseDown} onMouseUp={this.handleMouseUp} onMouseOut={this.handleMouseOut} data = "1" src={Icon1} className ={feature_icon[0]} alt="Feature Diagram"></img>

                                <h2 className="IE-Safe">{this.contentParser("effective")}  </h2>
                            </a>
                        </Col>
                        <Col className="col-xs-5th">
                            <a onClick = {this.handleFeatureClick} data="1">
                                <img onMouseOver = {this.handleMouseOver} onMouseDown={this.handleMouseDown} onMouseUp={this.handleMouseUp} onMouseOut={this.handleMouseOut} data = "2" src={Icon2} className ={feature_icon[1]} alt="Feature Diagram"></img>
                                <h2 className="IE-Safe">{this.contentParser("safe")} </h2>
                            </a>
                        </Col>
                        <Col className="col-xs-5th">
                            <a onClick = {this.handleFeatureClick} data="2">
                                <img onMouseOver = {this.handleMouseOver} onMouseDown={this.handleMouseDown} onMouseUp={this.handleMouseUp} onMouseOut={this.handleMouseOut} data = "3" src={Icon3} className ={feature_icon[2]} alt="Feature Diagram"></img>
                                <h2 className="IE-Safe">{this.contentParser("easy")}  </h2>
                            </a>
                        </Col>
                        <Col className="col-xs-5th">
                            <a onClick = {this.handleFeatureClick} data="3">
                                <img onMouseOver = {this.handleMouseOver} onMouseDown={this.handleMouseDown} onMouseUp={this.handleMouseUp} onMouseOut={this.handleMouseOut} data = "4" src={Icon4} className ={feature_icon[3]} alt="Feature Diagram"></img>
                                <h2 className="IE-Safe">{this.contentParser("bad_breath")}  </h2>
                            </a>
                        </Col>
                        <Col className="col-xs-5th">
                            <a onClick = {this.handleFeatureClick} data="4">
                                <img onMouseOver = {this.handleMouseOver} onMouseDown={this.handleMouseDown} onMouseUp={this.handleMouseUp} onMouseOut={this.handleMouseOut} data = "5" src={Icon5} className ={feature_icon[4]} alt="Feature Diagram"></img>
                                <h2 className="IE-Safe">{this.contentParser("cutting")}

                                </h2>
                            </a>
                        </Col>

                    </Row>
                </div>

                {curr_feature}
            </div>
        )


    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/Home.js